export const lightTheme = {
  cardGreen: "#85D07B",
  cardOrange: "#D7191C",
  cardBlue: "#2B83BA",
  cardYellow: "#FDAE61",
  DarkBlack: "#000000",
  TextBlack: "#454545",
  DarkOrange: "#E75300",
  green: "#00BC80",
  darkGreen: "#006B48",
  lightGreen2: "#45B68D",
  darkGreen2: "#022C12",
  default: "#F8F8F8",
  WillingGreen: "#00C283",
  littleGreen: "#E6F9F3",
  blue: "#009EFB",
  Teal: "#038c96",
  yellow: "#F29F26",
  liteBlue: "#018FA4",
  grayBlue: "#366474",
  TimeText: "#14181F",
  littleBlue: "#009EFB1A",
  red: "#DA0000",
  littleRed: "#DA00000F",
  backdrop: "#0000003D",
  borderColor: "#D9D9D9",
  gray: "#959595",
  orange: "#FF8B00",
  littleOrange: "#FF8B001A",
  black: "#292929",
  white: "#FFFFFF",
  bgGray: "#F1F1F1",
  ratingColor: "#FFB300",
  skin: "#FFEEE9",
  violet: "#9E00BA",
  lightGreen: "#E6F9F380",
  littleViolet: "#9E00BA1A",
  gold: "#A37300",
  lightgray: "#EEEEEE",
  text: {
    primary: "#000000",
    secondary: "#454545",
    tertiary: "#606067",
    quaternary: "#FFFFFF",
    orange: "#FFC200",
  },
  border: {
    primary: "#D9D9D9",
    secondary: "#DCDCDC",
  },
  background: {
    primary: "#FFFFFF",
    secondary: "#F8F8F8",
    tertiary: "#FDEEEB",
    foreground: "#B8B4FF",
  },
  font: "OpenSans-Medium",
  fontBold: "OpenSans-Bold",
  fontSemiBold: "OpenSans-SemiBold",
  fontRegular: "OpenSans-Regular",
};

export const darkTheme = {
  cardGreen: "#85D07B",
  cardOrange: "#D7191C",
  cardBlue: "#2B83BA",
  cardYellow: "#FDAE61",
  DarkBlack: "#FFFFFF", // Changing the deepest black to white for text on dark backgrounds
  TextBlack: "#E0E0E0", // Lighter gray for regular text
  DarkOrange: "#FF8B00", // Bright orange for highlights
  green: "#00E598", // Bright green with high contrast
  darkGreen: "#00BC80", // Slightly lighter green for readability
  lightGreen2: "#66D8B5", // Softer light green accent
  darkGreen2: "#00472A", // Darker green for depth
  default: "#1E1E1E", // Dark default background
  WillingGreen: "#00FFB0", // Vibrant green highlight
  littleGreen: "#00573A", // Subtle green background
  blue: "#009EFB", // Bright blue for accents
  Teal: "#039EA8", // Bright teal for accents
  yellow: "#F2C94C", // Softer yellow
  liteBlue: "#024A58", // Darker blue for accents
  grayBlue: "#2C4852", // Dark gray-blue for backgrounds
  TimeText: "#E0E0E0", // Light color for time text
  littleBlue: "#013A4C", // Subtle blue background tint
  red: "#FF4A4A", // Bright red for errors
  littleRed: "#520000", // Darker red accent
  backdrop: "#000000A0", // Darker semi-transparent backdrop
  borderColor: "#444444", // Darker border for dark mode
  gray: "#B3B3B3", // Light gray for dark background
  orange: "#FF8B00", // Bright orange
  littleOrange: "#7A3D00", // Darker orange background accent
  black: "#E0E0E0", // Light for readability
  white: "#000000", // Dark background substitute for white
  bgGray: "#333333", // Darker background gray
  ratingColor: "#FFCC33", // Gold for ratings
  skin: "#FFC4B2", // Soft pinkish highlight
  violet: "#A833FF", // Bright violet for accents
  lightGreen: "#005F47", // Subtle dark green
  littleViolet: "#4B007D", // Dark violet background
  gold: "#B98900", // Rich gold
  lightgray: "#444444", // Darker gray for backgrounds
  text: {
    primary: "#FFFFFF", // White for primary text
    secondary: "#E0E0E0", // Lighter gray for secondary text
    tertiary: "#B3B3B3", // Medium gray for tertiary text
    quaternary: "#1E1E1E", // Very dark for contrast against light elements
    orange: "#FF5E3A", // Soft, bright orange for special text
  },
  border: {
    primary: "#444444", // Darker border color
    secondary: "#555555", // Slightly lighter for contrast
  },
  background: {
    primary: "#000000", // Main background
    secondary: "#2C2C2C", // Secondary background
    tertiary: "#332726", // Darker tertiary background for contrast
    foreground: "#070628",
  },
  font: "OpenSans-Medium", // Keeping the fonts the same
  fontBold: "OpenSans-Bold",
  fontSemiBold: "OpenSans-SemiBold",
  fontRegular: "OpenSans-Regular",
};
export const colors = lightTheme;
